/* Daun Sirih PDP enhancer — bundle cards, unit prices, ETA */
(function () {
  var cfgEl = document.getElementById('ds-config');
  if (!cfgEl) return;
  var cfg = {};
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var main = document.querySelector('#MainContent > [id$="__main"]');
  if (!main) return;

  function money(c) {
    var amt = (c / 100).toFixed(2);
    return (cfg.money || 'RM {{amount}}').replace(/\{\{\s*\w+\s*\}\}/, amt);
  }
  function el(tag, cls, html) { var n = document.createElement(tag); if (cls) n.className = cls; if (html != null) n.innerHTML = html; return n; }

  var variants = [];
  function loadVariants() {
    var s = main.querySelector('variant-radios script[type="application/json"], variant-selects script[type="application/json"]');
    if (s) { try { variants = JSON.parse(s.textContent); } catch (e) {} }
    if (!variants.length && cfg.variants && cfg.variants.length) variants = cfg.variants;
  }
  function currentVariant() {
    var inp = main.querySelector('input.product-variant-id[name="id"], form[id^="product-form"] input[name="id"]');
    var id = inp ? Number(inp.value) : null;
    for (var i = 0; i < variants.length; i++) if (variants[i].id === id) return variants[i];
    return variants[0];
  }
  function units(v) {
    var t = v.title || '';
    var m = t.match(/(\d+)\s*(?:pads|pcs|pc|pieces)/i);
    var per = m ? Number(m[1]) : defaultPer(v);
    var b = t.match(/bundle of\s*(\d+)/i) || t.match(/(\d+)\s*packs?\b/i);
    var packs = b ? Number(b[1]) : 1;
    return { per: per, packs: packs, total: per * packs };
  }
  function defaultPer(v) {
    for (var i = 0; i < variants.length; i++) {
      var w = variants[i]; if (w === v) continue;
      var same = true;
      for (var o = 0; o < w.options.length; o++) { if (o !== bundleIdx && w.options[o] !== v.options[o]) { same = false; break; } }
      var mm = same && (w.title || '').match(/(\d+)\s*(?:pads|pcs|pc|pieces)/i);
      if (mm) return Number(mm[1]);
    }
    return 0;
  }
  function perUnit(v) { var u = units(v); return u.total ? v.price / u.total : null; }

  var fieldsets = [], bundleIdx = -1, sizeIdx = -1;
  function classify() {
    fieldsets = Array.prototype.slice.call(main.querySelectorAll('variant-radios fieldset'));
    fieldsets.forEach(function (fs, i) {
      var vals = Array.prototype.map.call(fs.querySelectorAll('input[type=radio]'), function (x) { return x.value; }).join('|');
      var legend = (fs.querySelector('legend') || {}).textContent || '';
      if (/bundle|single pack/i.test(vals) || /bundle/i.test(legend)) { bundleIdx = i; fs.classList.add('ds-bundle'); }
      else if (/\d+\s*cm/i.test(vals)) { sizeIdx = i; fs.classList.add('ds-size'); }
    });
  }
  function wrapLabel(label) {
    if (label.querySelector('.ds-orig')) return;
    var orig = el('span', 'ds-orig');
    Array.prototype.slice.call(label.childNodes).forEach(function (n) {
      if (n.nodeType === 3 && n.textContent.trim()) { orig.textContent = n.textContent.trim(); label.replaceChild(orig, n); }
    });
    if (!orig.parentNode) { orig.textContent = label.getAttribute('data-value') || ''; label.insertBefore(orig, label.firstChild); }
  }

  function sizeLabels() {
    if (sizeIdx < 0) return;
    var map = {};
    (cfg.sizeLabels || '').split('|').forEach(function (p) { var kv = p.split(':'); if (kv.length === 2) map[kv[0].trim().toLowerCase()] = kv[1].trim(); });
    fieldsets[sizeIdx].querySelectorAll('input[type=radio]').forEach(function (inp) {
      var label = inp.nextElementSibling; if (!label || label.tagName !== 'LABEL') return;
      wrapLabel(label);
      var key = (inp.value.match(/\d+\s*cm/i) || [''])[0].replace(/\s/g, '').toLowerCase();
      var orig = label.querySelector('.ds-orig');
      var m = inp.value.match(/^([^()]+)\(([^)]+)\)/);
      if (m && orig) orig.textContent = m[1].trim();
      var sub = label.querySelector('.ds-sub') || label.appendChild(el('span', 'ds-sub'));
      var count = m ? m[2].replace(/\/\s*pack/i, '').trim() : '';
      sub.textContent = [map[key], count].filter(Boolean).join(' · ');
    });
  }

  function findSibling(cur, idx, value) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], ok = true;
      for (var o = 0; o < v.options.length; o++) {
        if (o === idx) { if (v.options[o] !== value) { ok = false; break; } }
        else if (v.options[o] !== cur.options[o]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  function bundleCards(cur) {
    if (bundleIdx < 0 || !cur) return;
    var fs = fieldsets[bundleIdx];
    var inputs = Array.prototype.slice.call(fs.querySelectorAll('input[type=radio]'));
    var sibs = inputs.map(function (inp) { return findSibling(cur, bundleIdx, inp.value); });
    var single = sibs[0];
    var best = null, bestPU = Infinity;
    sibs.forEach(function (v) { if (!v) return; var pu = perUnit(v); if (pu && pu < bestPU) { bestPU = pu; best = v; } });
    var singlePU = single ? perUnit(single) : null;
    inputs.forEach(function (inp, i) {
      var v = sibs[i]; var label = inp.nextElementSibling; if (!label || label.tagName !== 'LABEL') return;
      wrapLabel(label);
      var box = label.querySelector('.ds-b'); if (!box) { box = el('span', 'ds-b'); label.appendChild(box); }
      if (!v) { box.innerHTML = '<span class="ds-b__dot"></span><span class="ds-b__name">' + inp.value + '</span>'; return; }
      var u = units(v), pu = perUnit(v);
      var name = inp.value.replace(/\s*\(.*?\)\s*/g, ' ').trim();
      var unitTxt = [];
      if (u.packs > 1) unitTxt.push(money(Math.round(v.price / u.packs)) + ' / pack');
      if (pu) unitTxt.push(money(Math.round(pu)) + ' / ' + (cfg.unit || 'pad'));
      if (u.packs === 1 && u.per) unitTxt.unshift(u.per + ' ' + (cfg.unitPlural || 'pcs'));
      var tags = '';
      var isBest = best === v && singlePU && bestPU < singlePU * 0.97;
      if (/free/i.test(inp.value)) tags += '<span class="ds-tag ds-tag--gift">' + (cfg.tagGift || 'Free gift') + '</span>';
      if (v.compare_at_price && v.compare_at_price > v.price) tags += '<span class="ds-tag ds-tag--save">' + (cfg.tagSave || 'Save') + ' ' + money(v.compare_at_price - v.price) + '</span>';
      if (cfg.threshold && v.price >= cfg.threshold) tags += '<span class="ds-tag ds-tag--ship">' + (cfg.tagShip || 'Free shipping') + '</span>';
      box.innerHTML = '<span class="ds-b__dot"></span>' +
        '<span class="ds-b__name">' + name + '</span>' +
        '<span class="ds-b__unit">' + unitTxt.join(' · ') + '</span>' +
        '<span class="ds-b__price"><b>' + money(v.price) + '</b>' + (v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s>' : '') + '</span>' +
        '<span class="ds-b__tags">' + tags + '</span>';
      var rib = label.querySelector('.ds-ribbon');
      if (isBest) { if (!rib) { rib = el('span', 'ds-ribbon'); label.appendChild(rib); } rib.textContent = cfg.tagBest || 'Best value'; }
      else if (rib) rib.remove();
    });
  }

  function priceMeta(cur) {
    if (!cur) return;
    var price = main.querySelector('[id^="price-"]');
    if (!price) return;
    var meta = main.querySelector('.ds-price-meta');
    if (!meta) { meta = el('div', 'ds-price-meta'); price.parentNode.insertBefore(meta, price.nextSibling); }
    var h = '';
    if (cur.compare_at_price > cur.price) {
      h += '<s>' + money(cur.compare_at_price) + '</s><span class="ds-save">-' + Math.floor((1 - cur.price / cur.compare_at_price) * 100 + 0.01) + '%</span>';
    }
    var pu = perUnit(cur);
    if (pu) h += '<span class="ds-unit">' + money(Math.round(pu)) + ' / ' + (cfg.unit || 'pad') + '</span>';
    meta.innerHTML = h;
  }

  function atcPrice(cur) {
    var btn = main.querySelector('.product-form__submit');
    if (!btn || !cur) return;
    var span = btn.querySelector('.ds-atc-price');
    if (!cur.available) { if (span) span.remove(); return; }
    if (!span) { span = el('span', 'ds-atc-price'); var txt = btn.querySelector('span'); if (txt) txt.after(span); else btn.appendChild(span); }
    var qtyIn = main.querySelector('.quantity__input');
    var q = qtyIn ? Math.max(1, Number(qtyIn.value) || 1) : 1;
    span.textContent = money(cur.price * q);
  }

  function hideEmptyReviews() {
    var r = main.querySelector('.review-link');
    if (r && /\(\s*0?\s*\)\s*$/.test(r.textContent.trim())) {
      var blk = r.closest('.product__info-container > *') || r; blk.style.display = 'none';
    }
  }

  function eta() {
    document.querySelectorAll('[data-ds-eta]').forEach(function (box) {
      var min = Number(box.getAttribute('data-min') || 2), max = Number(box.getAttribute('data-max') || min);
      var now = new Date(new Date().toLocaleString('en-US', { timeZone: 'Asia/Kuala_Lumpur' }));
      function add(n) { var d = new Date(now); var k = 0; while (k < n) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) k++; } return d; }
      var f = { weekday: 'short', day: 'numeric', month: 'short' };
      var a = add(min).toLocaleDateString('en-GB', f), b = add(max).toLocaleDateString('en-GB', f);
      var t = box.querySelector('[data-ds-eta-date]'); if (t) t.textContent = min === max ? a : a + ' – ' + b;
    });
  }

  function cleanTitle() {
    var h = main.querySelector('.product__title h1, .product__title h2');
    if (h && /^\s*\[[^\]]+\]\s*/.test(h.textContent)) h.textContent = h.textContent.replace(/^\s*\[[^\]]+\]\s*/, '');
  }

  function refresh() { var cur = currentVariant(); bundleCards(cur); priceMeta(cur); atcPrice(cur); }

  function init() {
    loadVariants(); classify(); sizeLabels(); refresh(); hideEmptyReviews(); eta(); cleanTitle();
    var vr = main.querySelector('variant-radios, variant-selects');
    if (vr) vr.addEventListener('change', function () { setTimeout(refresh, 30); setTimeout(refresh, 400); });
    main.addEventListener('change', function (e) { if (e.target && e.target.classList && e.target.classList.contains('quantity__input')) atcPrice(currentVariant()); });
    main.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.quantity__button')) setTimeout(function () { atcPrice(currentVariant()); }, 30); });
    var btn = main.querySelector('.product-form__submit');
    if (btn && window.MutationObserver) new MutationObserver(function () { if (!btn.querySelector('.ds-atc-price')) atcPrice(currentVariant()); }).observe(btn, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();